import { render, staticRenderFns } from "./HorizontalDateItem.vue?vue&type=template&id=f6880576"
import script from "./HorizontalDateItem.vue?vue&type=script&lang=js"
export * from "./HorizontalDateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports